export default __webpack_public_path__ + "static/media/error-500.b52ef7b2.svg";